/**
 * Decide correct HIDDENproperty to check in browser;
 */
let HIDDEN = '';
let EVENTNAME = '';
if (typeof document.hidden !== 'undefined') {
    HIDDEN = 'hidden';
    EVENTNAME = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
    HIDDEN = 'msHidden';
    EVENTNAME = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
    HIDDEN = 'webkitHidden';
    EVENTNAME = 'webkitvisibilitychange';
}

export default {
    HIDDEN,
    EVENTNAME
};
